import React, {Component} from "react";
import Home from "./Home/Home";

class App extends Component {
  componentDidMount() {
    document.title = "Lyxig säng med justerbar fasthet | Modilect";
  }

  state = {
    showContactModal: false
  };

  setShowContactModal = () => {
    this.setState({showContactModal: true});
  };
  setHideContactModal = () => {
    this.setState({showContactModal: false});
  };
  render() {
    return (<Home
      showContactModal={this.state.showContactModal}
      setHideContactModal={this.setHideContactModal}
      setShowContactModal={this.setShowContactModal}/>);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js